export default {
  props: {
    delay: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: 'primary',
    },
    colorful: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: true,
    },
    blur: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      shouldShow: true,
    }
  },
  created() {
    if (this.delay) {
      this.shouldShow = false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.$emit('input', value)
        if (value) {
          this.scheduleShow()
        } else {
          this.shouldShow = false
        }
      },
    },
  },
  methods: {
    scheduleShow() {
      clearTimeout(this.scheduleShowHandler)
      this.scheduleShowHandler = setTimeout(() => {
        this.shouldShow = this.value
      }, this.delay)
    },
  },
  render() {
    const hasContent = !!this.$slots.default

    if (!hasContent) {
      return this.renderLoading()
    }

    return (
      <div
        class={{
          'km-loading__section': true,
          'km-loading__section--active': this.shouldShow,
          'km-loading__section--blur': this.shouldShow && this.blur,
        }}
      >
        {
          this.shouldShow
            ? <div class="km-loading__section-loading">
              {this.renderLoading()}
            </div> : null
        }
        <div class="km-loading__section-content">
          {this.$slots.default}
        </div>
      </div>
    )
  },
}
